import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { SmsConsent } from '../common/SmsConsent';

const inputClasses =
  'mt-2 bg-[#050814] border-[#B8860B]/30 text-[#F4F1EA] placeholder:text-[#F4F1EA]/40 focus-visible:ring-[#B8860B]';

export const GuestInfoForm = ({ formData, onInputChange, guests, onGuestsChange, campingType, onCampingTypeChange, smsConsent, onSmsConsentChange, onSubmit }) => {
  return (
    <Card
      data-testid="guest-info-card"
      className="border border-[#B8860B]/30 shadow-xl bg-[#0B132B]"
    >
      <CardHeader>
        <CardTitle className="text-2xl text-[#F4F1EA]">Guest Information</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="firstName" className="text-[#F4F1EA]">First Name *</Label>
              <Input
                data-testid="guest-first-name-input"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={onInputChange}
                required
                className={inputClasses}
              />
            </div>
            <div>
              <Label htmlFor="lastName" className="text-[#F4F1EA]">Last Name *</Label>
              <Input
                data-testid="guest-last-name-input"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={onInputChange}
                required
                className={inputClasses}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="email" className="text-[#F4F1EA]">Email *</Label>
              <Input
                data-testid="guest-email-input"
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={onInputChange}
                required
                className={inputClasses}
              />
            </div>
            <div>
              <Label htmlFor="phone" className="text-[#F4F1EA]">Phone *</Label>
              <Input
                data-testid="guest-phone-input"
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={onInputChange}
                required
                className={inputClasses}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="guests" className="text-[#F4F1EA]">Number of Guests</Label>
              <Select value={guests} onValueChange={onGuestsChange}>
                <SelectTrigger data-testid="guests-select" className="mt-2 bg-[#050814] border-[#B8860B]/30 text-[#F4F1EA]">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <SelectItem key={num} value={num.toString()}>
                      {num} {num === 1 ? 'Guest' : 'Guests'}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label htmlFor="campingType" className="text-[#F4F1EA]">Camping Type</Label>
              <Select value={campingType} onValueChange={onCampingTypeChange}>
                <SelectTrigger data-testid="camping-type-select" className="mt-2 bg-[#050814] border-[#B8860B]/30 text-[#F4F1EA]">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="tent">Tent Camping</SelectItem>
                  <SelectItem value="rv">RV/Camper</SelectItem>
                  <SelectItem value="other">Other</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <SmsConsent
            testid="booking-sms-consent"
            checked={smsConsent}
            onChange={onSmsConsentChange}
          />
        </form>
      </CardContent>
    </Card>
  );
};
